import {
  SET_WS_STATE,
  SET_WS_AUTH,
  READ_NOTIFICATION
} from '@/store/modules/notify/types';

export default {
  [SET_WS_STATE]: (state, data) => {
    state.WSopen = data;
  },
  [SET_WS_AUTH]: (state, data) => {
    state.WSauth = data;
  },
  [READ_NOTIFICATION]: (state, id) => {
    const readItem = state.WSunreadNotifications.find(i => i.id === id);

    state.WSunreadNotifications.splice(state.WSunreadNotifications.indexOf(readItem), 1);
  }
};
